import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const PizzaChartWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  /* 240px dial + the 10.5px each side the over-performance arrows overhang into. */
  width: 100%;
  max-width: 261px;
  max-height: 100%;
  aspect-ratio: 261 / 240;

  img {
    position: absolute;
    width: 434px;
    height: 418px;
    top: 147px;
    border-radius: ${theme.attributes.borderRadius.circle};
  }

  /* Square dial sized off the column height, so it keeps its 240/261 share as the card narrows. */
  .performance-score-chart-svg {
    height: 100%;
    width: auto;
    overflow: visible;
  }
`

export const SetupWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column wrap;
  position: absolute;
  z-index: 1;

  .setup-title {
    color: ${theme.colors.foreground};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.huge};
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 52px;
    max-width: 334px;
    margin-bottom: 21px;
  }
`
